import React, { useCallback } from 'react';
import { ListGroup } from 'react-bootstrap';
import Drawer from '../Drawer';
import Dialog from '../Dialog-box';
import languageSelection from '../../images/ic_language.svg';
import useBoolean from '../../hooks/use-boolean';
import useTranslation from '../../hooks/use-translation';
import closeIcon from '../../images/ic_close.svg';
import { useIsDesktop, useIsTablet } from '../../hooks/breakpoints';

const styles = {
  buttonContainer: {
    textAlign: 'right',
    marginRight: '1em'
  },
  buttonContainerDesktop: {
    textAlign: 'right'
  },
  button: {
    background: 'none',
    border: 0,
    outline: 'none',
    width: "2.5rem",
    height: "2.5rem"
  }
};

export default () => {
  const [isOpen, open, close] = useBoolean();
  const { supportedLanguages, setLanguage } = useTranslation();
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();

  const onLanguageSelected = useCallback(languageCode => () => {
    setLanguage(languageCode);
    close();
  }, [close, setLanguage]);

  return (
    <div style={(isDesktop || isTablet) ? styles.buttonContainerDesktop : styles.buttonContainer}>
      <button style={styles.button} onClick={open}>
        <img
          src={languageSelection}
          width="30"
          height="30"
          alt=""
          style={{
            width: "2rem",
            height: "2rem"
          }}
        />
      </button>
      {(isDesktop || isTablet) ? (
        <Dialog
          open={isOpen}
          dialogType="listpopup"
          labelHead={() => (
            <div className="popupToolbarCon">
              <span className="flex">
                <span className="drawerHeaderText">{t('LANGUAGE_TITLE')}</span>
              </span>
              <button style={styles.button} onClick={close}>
                <img className="closeIcon" src={closeIcon} alt="" />
              </button>
            </div>
          )}
          listItem={() => (
            <ListGroup>
              {Object.entries(supportedLanguages).map(([languageCode, languageName]) => (
                <ListGroup.Item
                  className="list-item"
                  variant="light"
                  style={{
                    outline: 'none', boxShadow: '0px 2px 4px #0000001A', width: '25em', height: '3.625em', borderRadius: '0.25em'
                  }}
                  key={languageCode}
                  action
                  onClick={onLanguageSelected(languageCode)}
                >
                  {languageName}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        />
      ) : (
          <Drawer open={isOpen} onClose={close} heading="Languages">
            <ListGroup>
              {(Object.entries(supportedLanguages)).map(([languageCode, languageName]) => (
                <ListGroup.Item
                  className="list-item"
                  variant="light"
                  style={{ outline: 'none', boxShadow: 'none' }}
                  key={languageCode}
                  action
                  onClick={onLanguageSelected(languageCode)}
                >
                  {languageName}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Drawer>
        )}
    </div>
  );
};
